export const URBANIK_RELEASE = {
    version: '1.0.0',
    releaseId: '2026.09.08',
    releasedAt: '2026-09-08',
    title: 'Base multi-entidad y operación institucional',
    changes: [
        {
            title: 'Multi-entidad',
            items: [
                'Contexto obligatorio de entidad activa y validación institucional por petición.',
                'Aislamiento de socios, cupos, obligaciones, pagos, cuentas, actas, conceptos e importaciones.',
                'Claves privadas de comprobantes separadas por entidad y socio.',
            ],
        },
        {
            title: 'Socios y acceso',
            items: [
                'Alta, edición y consulta con identidad y contacto propios de cada entidad.',
                'Acceso inicial mediante cédula y cambio obligatorio de contraseña.',
                'Capacidad institucional y números de socio con acciones auditadas.',
            ],
        },
        {
            title: 'Pagos y operación',
            items: [
                'Registro, revisión, distribución y reverso auditado de comprobantes.',
                'Cuentas receptoras, obligaciones y saldos filtrados por la entidad activa.',
                'Importación masiva mediante plantilla y diagnósticos institucionales claros.',
                'Apertura segura de documentos y comprobantes sin perder la sesión ni la entidad activa.',
                'Recibos oficiales con tipografía compatible para tildes, eñes y símbolos.',
            ],
        },
        {
            title: 'Experiencia y actualización',
            items: [
                'Selector institucional y formularios alineados con los componentes canónicos.',
                'Actualización automática de la PWA y limpieza de cachés obsoletas.',
                'Nueva sección global para consultar versión, plataforma y novedades.',
            ],
        },
    ],
};
